import { IBorrowList } from "../../models/IBorrowList";

export class BorrowState {
  borrowList: IBorrowList[] = [];
}
